import React, { ReactNode, useContext } from "react";
import { QuickFilterContext, QuickFilterProviderValue } from "./QuickFilterProvider";
import IconButton, { IconButtonColor } from "components/Shared/IconButton";
import { stat } from "fs";

interface Props {
  baseQuery: string,
  selectedHeader?: boolean,
}

const QuickFilterStatusIcon = ({ baseQuery }: Props) => {
  const { getFilterStatusForBasyQuery } = useContext<QuickFilterProviderValue>(QuickFilterContext);

  const status = getFilterStatusForBasyQuery(baseQuery);

  if (status.appliedFilters.length === 0 && status.invalidFilters.length === 0) return null;

  let color: IconButtonColor = "green";
  let icon = "check";
  
  if (status.invalidFilters.length) {
    icon = "priority_high";
    color = "red";
  }

  let tooltipLines: ReactNode[] = [];

  if (status.appliedFilters.length) {
    tooltipLines.push("Applicable Quick Filters:", ...status.appliedFilters.map(k => k.name));
  }

  if (status.invalidFilters.length) {
    if (tooltipLines.length) tooltipLines.push(<br />);
    tooltipLines.push("Invalid Quick Filters:", ...status.invalidFilters.map(k => k.name));
  }

  return (
    <IconButton
      icon={icon}
      iconColor={color}
      tooltip={tooltipLines.map(l => <div>{l}</div>)}
      style={{ position: 'absolute', top: 0, right: 0 }}
    />
  );
};

export default QuickFilterStatusIcon;
